/** Creates a scaleable vector graphic */
export default class BADGE_CIRCLE {
    createSVGElementModel(text) {
        return {
            element: 'svg',
            attributes: {
                id: 'symbol',
                class: 'badge-circle',
                xmlns: 'http://www.w3.org/2000/svg',
                version: '1.1',
                viewBox: '0 0 512 512'
            },
            data: {
                children: [
                    {
                        element: 'circle',
                        attributes: {
                            id: 'circle',
                            cx: '256',
                            cy: '256',
                            r: '192',
                            fill: '#231f20'
                        },
                        data: {
                            children: []
                        },
                        meta: {}
                    },
                    {
                        element: 'text',
                        attributes: {
                            id: 'text',
                            x: '256',
                            y: '256',
                            fill: '#fff',
                            'font-family': 'ArialMT, Arial',
                            'font-size': '20em',
                            'text-anchor': 'middle',
                            'dominant-baseline': 'central'
                        },
                        data: {
                            children: [
                                {
                                    element: 'tspan',
                                    attributes: {
                                        x: '256'
                                    },
                                    data: {
                                        children: [],
                                        text
                                    },
                                    meta: {}
                                }
                            ]
                        },
                        meta: {}
                    }
                ]
            },
            meta: {}
        };
    }
}
